// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__33CmM","boxTitle":"Qualiphy_boxTitle__1NJkC","box":"Qualiphy_box__TQbUJ","toggleWrap":"Qualiphy_toggleWrap__ojiYY"};